// extracted by mini-css-extract-plugin
module.exports = {"Cards":"ProjectGrid_Cards__3_WPV","Title":"ProjectGrid_Title__24OWR","Cards2":"ProjectGrid_Cards2__3dPSL","Title2":"ProjectGrid_Title2__3QWeL"};